import React from "react";
import * as S from "./HomeStyle";
import Menu from "./Menu";
import Header from "./Header";

import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import styled from "styled-components";

const SelectType = () => {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.clear();
    localStorage.clear();
  }, []);
  return (
    <>
      <Header />
      <S.Container>
        <Menu />
        <S.Content>
          <S.PageTitle>위해성 평가 방식 선택</S.PageTitle>
          <S.EvalArea>
            <S.PaddingBox>
              <Container>
                <S.EvalBox>
                  <S.PaddingBox>
                    <h3>기본평가</h3>
                    <p>
                      기존 데이터를 바탕으로 한 간단한 위해성 평가 모델로,
                      단일/복합 오염물질의 오염원, 경로, 수용체 정보를 숫자
                      값으로 입력 받아 위해도 값을 산출합니다.
                    </p>
                    <Img2 src="/img/tier1.png" alt="Tier 1" />
                  </S.PaddingBox>
                </S.EvalBox>
                <S.EvalBox>
                  <S.PaddingBox>
                    <h3>부지기반평가</h3>
                    <p>
                      공간 특징적인 데이터를 바탕으로 심화된 현실적인 위해성
                      평가 모델로, 단일 오염물질의 오염원, 경로, 수용체 정보를
                      그리드로 입력 받아 위해도 그리드를 산출합니다.
                    </p>
                    <Img2 src="/img/tier23.png" alt="Tier 2/3" />
                  </S.PaddingBox>
                </S.EvalBox>
              </Container>
            </S.PaddingBox>
          </S.EvalArea>

          <BtnAreaSolo>
            <S.PrevBtn onClick={() => navigate(-1)}>뒤로</S.PrevBtn>
          </BtnAreaSolo>
        </S.Content>
      </S.Container>
    </>
  );
};

export default SelectType;

const Container = styled.div`
  display: flex;
  justify-content: space-evenly;
`;

const BtnAreaSolo = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 3%;
`;
const Img2 = styled.img`
  width: 80%;
  margin: 3rem;
`;
